<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="w-full" :style="`background-color: ${cmsData.hero[0].backgroundColor.hex}`">
    <div class="container-wrap">
      <section
        v-if="cmsData"
        id="mini-checkout-form"
        ref="miniCheckoutForm"
        class="relative mini-checkout-form grid grid-cols-12"
        :class="{ 'bg-infra-violette': !cmsData.hero[0].backgroundColor }"
        :style="`background-color: ${cmsData.hero[0].backgroundColor.hex}`"
      >
        <div class="col-span-10 col-start-2 grid grid-cols-12 flex items-center justify-center lg:justify-start flex-col lg:flex-row">
          <div class="col-span-12 lg:col-span-6 mt-0">
            <h2
              v-if="isReferral && !appStore.isReferralLinkValid"
              class="font-druk uppercase px-0 signup_title text-display-14 lg:text-display-25 text-center lg:text-left tracking-wide inner-container"
              :style="`color: ${cmsData.hero[0].splashTitleTextColor.hex}`"
            >
              {{
                formatTitle(cmsData.hero[0].titleInvalid)
              }}
            </h2>
            <h2
              v-else
              class="font-druk uppercase px-0 signup_title text-display-14 lg:text-display-25 text-center lg:text-left tracking-wide inner-container"
              :style="`color: ${cmsData.hero[0].splashTitleTextColor.hex}`"
            >
              {{
                !appStore.completedReferralFlow
                  ? formatTitle(cmsData.hero[0].splashTitle)
                  : formatTitle(cmsData.hero[0].splashTitleSignupSuccess)
              }}
            </h2>
            <div
              v-if="isReferral && !appStore.isReferralLinkValid"
              class="mt-6 lg:mt-2 mb-6 lg:mt-standart text-white lg:mb-medium signup_subtitle text-center lg:text-left inner-container"
              v-html="cmsData.hero[0].bodyTextInvalid"
            />
            <div
              v-else
              class="mt-6 lg:mt-2 mb-6 lg:mt-standart text-white lg:mb-medium signup_subtitle text-center lg:text-left inner-container"
              v-html="
                !appStore.completedReferralFlow
                  ? cmsData.hero[0].splashBodyText
                  : cmsData.hero[0].splashBodyTextSignupSuccess
              "
            />

            <div v-if="!appStore.completedReferralFlow" class="inner-container">
              <div
                class="w-full py-semi px-tiny lg:px-semi bg-white signup-wrapper"
              >
                <SignupPhoneNumberEntry
                  :cms-data="cmsData.firstStep[0]"
                  @next="openModal()"
                />
              </div>
            </div>

            <div
              v-if="(!isReferralFlow || (appStore.completedReferralFlow && $device.isDesktop))"
              class="mt-7 flex justify-center lg:justify-start items-end"
            >
              <div
                v-if="isReferralFlow"
                class="app-qr hidden md:block shrink-0 mr-medium"
              >
                <img
                  loading="lazy"
                  src="https://majority.imgix.net/web-assets/shared/majority-app-qr.svg"
                  alt="QR code"
                >
              </div>
              <!-- <button class="p-0 text-white h-8 mr-medium" aria-label="App store" @click="goToAppStore">
            <img loading="lazy" src="/appstorelogo.png" alt="App store" class="h-full mx-auto">
          </button>
          <button class="p-0 text-white h-8" aria-label="Google Play store" @click="goToAppStore">
            <img loading="lazy" src="/googleplaylogo.png" alt="Google Play store" class="h-full mx-auto">
          </button> -->
            </div>

            <div
              v-if="$device.isMobileOrTablet && isReferralFlow && appStore.completedReferralFlow"
              class="w-full flex justify-center"
            >
              <button
                type="button"
                class="md:hidden btn btn-black p-2 px-12 text-white"
                @click="goToAppStore"
              >
                {{ $messages('label.download_majority') }}
              </button>
            </div>
          </div>
          <div
            v-if="cmsData.hero[0].splashImage"
            class="hidden lg:block col-span-6 order-first lg:order-last"
            :class="[
              cmsData.hero[0].fullScreenImage
                ? 'h-full'
                : '',
              !isReferralFlow || (isReferralFlow && !appStore.completedReferralFlow) ? 'hidden' : '',
            ]"
          >
            <img
              v-if="isReferral && !appStore.isReferralLinkValid"
              loading="lazy"
              class="mx-auto"
              :class="
                cmsData.hero[0].fullScreenImage
                  ? 'object-contain object-center h-full w-full'
                  : !isReferralFlow
                    ? 'splash-screen-image'
                    : !appStore.completedReferralFlow
                      ? 'signup_splash_image'
                      : 'signup_splash_image_flow_completed'
              "
              :src="cmsData.hero[0].invalidImage.url"
              :alt="cmsData.hero[0].invalidImage.alt || ''"
            >
            <img
              v-else
              loading="lazy"
              class="mx-auto"
              :class="
                cmsData.hero[0].fullScreenImage
                  ? 'object-contain object-center h-full w-full'
                  : !isReferralFlow
                    ? 'splash-screen-image'
                    : !appStore.completedReferralFlow
                      ? 'signup_splash_image'
                      : 'signup_splash_image_flow_completed'
              "
              :src="cmsData.hero[0].splashImage.url"
              :alt="cmsData.hero[0].splashImage.alt || ''"
            >
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script setup>
import { applicationStore } from '~/store/application'
import request from '@/api/dato/datohelper'
import { CMS_WEB_SIGNUP_FLOW_QUERY } from '@/utils/graphql-queries'
import { getAppLink } from '~/utils/acquisition-helpers'

const props = defineProps({
  isReferral: {
    type: Boolean,
    default: false
  },
  referralData: {
    type: Object,
    default: () => ({})
  },
  referral: {
    type: Object,
    default: () => ({})
  },
  completedReferralFlow: {
    type: Boolean,
    default: false
  }
})

const { $env } = useNuxtApp()
const appStore = applicationStore()
const cmsData = ref(null)
const isReferralFlow = ref(false)
const route = useRoute()

const fetchCmsData = async () => {
  const currentLocale = useLocale() || 'en'
  const query = `query MyQuery {
        webSignupFlow(locale: ${currentLocale}) {
          ${CMS_WEB_SIGNUP_FLOW_QUERY}
        }
      }`
  try {
    let data = {}
    if (isReferralFlow.value && Object.keys(props.referralData).length > 0) {
      data = props.referralData
    } else {
      const apiData = await request(query, 'webSignupFlow' + currentLocale)
      data = apiData.webSignupFlow
    }
    return data
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err)
  }
}

const referralCookie = useCookie('referralId')
if (referralCookie.value) {
  isReferralFlow.value = true
}

cmsData.value = await fetchCmsData()

const openModal = () => {
  appStore.setSignupModalIsOpen(true)
}

const formatTitle = (title) => {
  if (title) {
    return title.replace(
      /{{name}}/g,
      props.referral ? props.referral.referredByUserFirstName : ''
    )
  }
  return title
}

const getAppsLink = computed(() => {
  return getAppLink(useCookie('channel').value, {
    utmSource: useCookie('utmSource').value,
    utmMedium: useCookie('utmMedium').value,
    utmCampaign: useCookie('utmCampaign').value,
    utmContent: 'app_download_icon',
    utmTerm: useCookie('utmTerm').value,
    pageUrl: `${$env.websiteUrl}${route.fullPath}`,
    virtualPageUrl: `${$env.websiteUrl}${route.path}`
  })
})

const goToAppStore = () => {
  window.open(getAppsLink.value, '_blank')
}

</script>

<style lang="postcss" scoped>
.signup-wrapper {
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.08);
  min-height: 300px;
  border-radius: 10px;
}

.inner-container {
  width: 100%;
  @screen lg {
    max-width: 500px;
  }
}

.app-qr {
  padding: 8px;
  width: 116px;
  height: 116px;
  background: #ffffff;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}

.splash-screen-image {
  max-height: 480px;
}

.signup_splash_image {
  width: 600px;
}

.signup_splash_image_flow_completed {
  width: 400px;
}

.signup_title {
  line-height: 95%;
}

.signup_subtitle {
  font-weight: 300;
  font-size: 28px;
  line-height: 110%;
}

.mini-checkout-form {
  padding: 72px 0px;
}

@media screen and (max-width: 1024px) {
  .signup_subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 110%;
  }
  .mini-checkout-form {
    padding: 48px 0px 42px 0px;
  }
}

@media screen and (max-width: 768px) {
  .signup_splash_image {
    width: 160px;
  }
}
</style>
